export class MapNodeMinimapSpec {
    constructor(public color: string = null,public icon: any = null,public additional: any = null
                // , public image = null
    ) {
    }
}
